import { useState } from "react";
import Sidebar from "@/components/Sidebar";
import { List, X } from "@phosphor-icons/react";

export default function Layout({ children }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="min-h-screen flex bg-[#F8F7F2] text-[#1F2933]">
      {/* Desktop sidebar */}
      <div className="hidden lg:flex sticky top-0 h-screen">
        <Sidebar />
      </div>

      {/* Mobile sidebar drawer */}
      {open && (
        <div className="lg:hidden fixed inset-0 z-40">
          <div className="absolute inset-0 bg-black/60" onClick={() => setOpen(false)} />
          <div className="absolute left-0 top-0 h-full">
            <Sidebar onNavigate={() => setOpen(false)} />
          </div>
        </div>
      )}

      <div className="flex-1 min-w-0 flex flex-col">
        {/* Mobile top bar */}
        <header className="lg:hidden sticky top-0 z-30 bg-white/90 backdrop-blur-xl border-b border-[#E7E2D4] px-4 h-14 flex items-center gap-3">
          <button
            onClick={() => setOpen(true)}
            className="h-9 w-9 rounded-md border border-[#E7E2D4] flex items-center justify-center"
            data-testid="mobile-menu-button"
          >
            <List size={18} />
          </button>
          <div className="flex items-center gap-2">
            <div className="h-9 w-14 rounded-lg bg-white border border-[#E2D8BE] shadow-sm flex items-center justify-center p-1"><img src="/amaia-logo.png" alt="Amaia Steps" className="max-h-7 max-w-full object-contain" /></div>
            <p className="font-heading font-bold">Amaia Steps Parking</p>
          </div>
        </header>

        <main className="flex-1 p-4 sm:p-6 lg:p-8 max-w-[1600px] w-full mx-auto">
          {children}
        </main>
      </div>
    </div>
  );
}
